module.exports = __webpack_public_path__ + "media/flags/ne-fb457059.svg";